@if (storage._storage !== null && common.currentLang && common.UUID) {
  <ion-app>
    <ion-split-pane contentId="menu-principale" when="(min-width: 0px)">
      <ion-router-outlet [animation]="animation" id="menu-principale"></ion-router-outlet>
    </ion-split-pane>
  </ion-app>
}
